import { Controller } from "@hotwired/stimulus"

export default class AusgezeichnetOrgBadgeController extends Controller {
  static values = { url: String }

  connect() {
    // register subscription for the cookie consent change
    App.cookieConsentStore?.subscribe(() => this.showBannerIfAllowed())

    this.showBannerIfAllowed()
  }

  showBannerIfAllowed() {
    if (App.cookieConsentStore?.read().marketing_enabled) {
      // Warning: If the #auorg-bg element does not contain at least one character,
      // the Ausgezeichnet.org script will not render the badge.
      this.element.innerHTML = '<div id="auorg-bg"> </div>'
      this.element.style.display = "block"

      const script = document.createElement("script")
      script.src = this.urlValue
      document.head.appendChild(script)
    }
  }
}
